/* eslint-disable no-case-declarations */
/* eslint-disable no-console */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useEffect, useState } from 'react';
import { Modal } from '@zeeve-platform/modal-component';
import { Breadcrumb } from '@zeeve-platform/breadcrumb-component';
import Endpoint from './endpoint';
import Security from './security';
import {
  EndpointTypes,
  SecurityTypes,
  WorkspaceType,
  ProtocolNetworkType,
} from './declaration';
import Urls from '../../utils/urls';
import CustomLoader from '../common/loader';
import apiBackendInstance from '../../utils/axios';
import { prefixPath } from '../../utils/helpers';

function CreateEndpointBody() {
  const [step, setStep] = useState<number>(1);
  const [endpointData, setEndpointData] = useState({} as EndpointTypes);
  const [securityData, setSecurityData] = useState({} as SecurityTypes);
  const [workspaces, setWorkspace] = useState([] as WorkspaceType[]);
  const [userPlan, setUserPlan] = useState<string>('');
  const [deployStatus, setDeployStatus] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [redirectionLink, setRedirectionLink] = useState('#');
  const [apiResponse, setApiResponse] = useState('');
  const [subscriptionId, setSubscriptionId] = useState<string>('');
  const [protocolNetworkTypeList, setProtocolNetworkTypeList] = useState(
    [] as ProtocolNetworkType[],
  );

  const paths = [
    { name: 'Dashboard', path: prefixPath('/dashboard') },
    { name: 'RPC Endpoint', path: prefixPath('/endpoints') },
  ];

  const getWorkspaceList = async () => {
    apiBackendInstance.get(Urls.getWorkSpaceList(), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (response && response.data && response.data.data) { setWorkspace(response.data.data); }
      })
      .catch((err) => { setWorkspace([]); console.error(err); });
  };

  const getProtocolNetworkTypeList = async () => {
    apiBackendInstance
      .get(Urls.protocolNetworkTypes(), {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        if (response && response.data && response.data.data) {
          setProtocolNetworkTypeList(response.data.data);
        }
      })
      .catch((err) => {
        setProtocolNetworkTypeList([]);
        console.error(err);
      });
  };

  const setStepActive = (n: number) => {
    for (let i: number = 1; i <= n + 1; i += 1) {
      const formStep = `step${i.toString()}${i.toString()}`;
      const ss: HTMLElement | null = document.getElementById(formStep);
      if (ss) {
        ss.style.opacity = '1';
        ss.style.backgroundColor = '#04AA6D';
      }
      if (i === n + 1 && ss) {
        ss.style.opacity = '1';
        ss.style.backgroundColor = '#FFC542';
      } else if (ss) {
        ss.style.opacity = '1';
        ss.style.backgroundColor = '#FFC542';
      }
    }
  };

  const renderComponent = () => {
    switch (step) {
      case 1:
        setStepActive(0);
        return (
          <Endpoint
            endpointData={endpointData}
            setEndpointData={setEndpointData}
            workspaces={workspaces}
            nextStep={nextStep}
            step={step}
            protocolNetworkTypeList={protocolNetworkTypeList}
          />
        );
      case 2:
        setStepActive(1);
        return (
          <Security
            securityData={securityData}
            setSecurityData={setSecurityData}
            prevStep={prevStep}
            submit={submit}
            step={step}
          />
        );
      default:
    }
  };

  const getUserPlanFromParams = () => {
    const params: any = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop: any) => searchParams.get(prop),
    });
    const { subsId, plan } = params;
    setUserPlan(plan);
    setSubscriptionId(subsId);
  };

  useEffect(() => {
    getProtocolNetworkTypeList();
    getWorkspaceList();
    getUserPlanFromParams();
  }, []);

  const prevStep = () => {
    setStep(1);
  };

  const nextStep = () => {
    setStep(2);
  };

  const submit = async () => {
    setShowLoader(true);
    const addOns: string[] = [];
    if (endpointData.addONs && endpointData.addONs.archiveMode) {
      addOns.push('Archive Mode');
    }
    if (endpointData.addONs && endpointData.addONs.traceMode) {
      addOns.push('Trace Mode');
    }
    const payload = {
      subscriptionId,
      name: endpointData.name,
      workspaceId: endpointData.workspaceId,
      serviceId: endpointData.serviceId,
      networkType: endpointData.networkType,
      viewableLabels: {
        'Network Type': endpointData.networkTypeName,
      },
      securityEnabled: securityData.requireJWT
        ? securityData.requireJWT
        : false,
      jwt: {
        enabled: securityData.requireJWT,
        name: securityData.JWTKeyName,
        publicKey: securityData.JWTKey,
      },
    };
    apiBackendInstance.post(Urls.getCreateEndpointUrl(), { ...payload }, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },

    })
      .then((response) => {
        if (response?.data?.data?.message) {
          setApiResponse(response.data.data.message);
        }
        if (response.data.success) {
          setDeployStatus(true);
          if (response?.data?.data?.redirectionUrl) {
            setRedirectionLink(response.data.data.redirectionUrl);
          }
          setShowLoader(false);
          setShowModal(true);
        } else {
          setShowLoader(false);
          setShowModal(true);
        }
      }).catch((err) => {
        const errMsg = err && err.response && err.response.data && err.response.data.message ? err.response.data.message : 'Error creating Endpoint';
        setApiResponse(`Error: ${errMsg}`);
        setShowLoader(false);
        setShowModal(true);
      });
  };
  return (
    <section className="px-5 col-12 workspace">
      <div className="mt-5 col-11 mx-auto">
        <div className="d-flex">
          <p className="fw-bold text-dark">RPC Endpoint Plan -</p>
          <p className="mx-2 text-muted">{userPlan}</p>
        </div>
        <div className="cursor d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <Breadcrumb prefixLink={paths} activeLink="create" />
          </div>
        </div>
      </div>
      <div className="card my-4 col-11 mx-auto">
        <div className="card-body p-0">
          <form className="border-bottom" id="regForm" action="">
            <div
              className="navbar border-bottom"
              style={{ justifyContent: 'left' }}
            >
              <h6 className="mt-4 ms-4 mb-4">
                <div
                  className={
                    step === 1
                      ? 'borderline border-margin paddingbottom'
                      : 'border-margin paddingbottom'
                  }
                >
                  <span className="step" id="step11" />
                  <span className="mx-2">RPC Endpoint</span>
                </div>
              </h6>
              <h6 className="mt-4 ms-4 mb-4">
                <div
                  className={
                    step === 2
                      ? 'borderline border-margin paddingbottom'
                      : 'border-margin paddingbottom'
                  }
                >
                  <span className="step" id="step22" />
                  <span className="mx-2">Security</span>
                </div>
              </h6>
            </div>
            {renderComponent()}
          </form>
        </div>
      </div>
      <CustomLoader showLoader={showLoader} />
      <Modal
        show={showModal}
        onHide={() => { setShowModal(false); }}
        title={`Creating ${endpointData.protocolName} RPC Endpoint`}
        confirmBtnText="Continue"
        visibleFooter
        visibleHeaderCloseIcon={false}
        onConfirm={() => window.open(redirectionLink, '_self')}
        visibleConfirmBtn={deployStatus}
        visibleFooterCloseButton={!deployStatus}
      >
        <p className="status text-center mt-3" id="modal_status">{apiResponse}</p>
      </Modal>
    </section>
  );
}

export default CreateEndpointBody;
